import React from 'react';

const FormSelect = ({ name, value, title, change, children, className }) => (
  <div className={className}>
    <div className="inline-block relative w-full">
      <label className="relative flex" htmlFor={name}>
        <select
          name={name}
          value={value}
          onChange={change}
          className="block w-full bg-gray-200 border-b-2 border-cf-300 p-4 pr-8 leading-tight focus:outline-none text-sm text-gray-700"
        >
          {children}
        </select>
        <span className="absolute top-0 left-0 pl-3 text-xs focus-within:hidden -mt-2 text-gray-600">
          {title}
        </span>
      </label>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-cf-300">
        <svg
          className="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>
  </div>
);

export default FormSelect;
